import { escapeAttr, escapeHtml } from "@emkit/builder-core";
export const HEADING_DEFAULTS = {
    text: "Heading",
    level: 2,
    align: "left",
};
export const headingWidget = {
    type: "heading",
    defaultProps: HEADING_DEFAULTS,
    renderHtml(props) {
        const level = Math.min(Math.max(props.level, 1), 6);
        const styleParts = [];
        if (props.align)
            styleParts.push(`text-align:${props.align}`);
        if (props.color)
            styleParts.push(`color:${escapeAttr(props.color)}`);
        const style = styleParts.length ? ` style="${styleParts.join(";")}"` : "";
        return `<h${level} class="emk-heading"${style}>${escapeHtml(props.text)}</h${level}>`;
    },
};
//# sourceMappingURL=heading.js.map